/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function e(){return[1,0,0,1,0,0]}function n(e){return[e[0],e[1],e[2],e[3],e[4],e[5]]}function r(e,n,r,t,a,o){return[e,n,r,t,a,o]}function t(e,n){return new Float64Array(e,n,6)}const a=Object.freeze({__proto__:null,create:e,clone:n,fromValues:r,createView:t});export{n as a,t as b,e as c,r as f,a as m};
